import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/Users/hqlin/code/xxd/npm/src/theme/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a id="synopsis"></a>
    <h3>{`概要`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm start [-- <args>]
`}</code></pre>
    <a id="description"></a>
    <h3>{`描述`}</h3>
    <p>{`这将运行在其 `}<inlineCode parentName="p">{`"scripts"`}</inlineCode>{` 对象的包的 `}<inlineCode parentName="p">{`"start"`}</inlineCode>{` 属性中指定的任意命令。 如果没有在 `}<inlineCode parentName="p">{`"scripts"`}</inlineCode>{` 对象上指定 `}<inlineCode parentName="p">{`"start"`}</inlineCode>{` 属性，它将运行 `}<inlineCode parentName="p">{`node server.js`}</inlineCode>{`。`}</p>
    <p>{`从 `}<a parentName="p" {...{
        "href": "https://blog.npmjs.org/post/98131109725/npm-2-0-0"
      }}><inlineCode parentName="a">{`npm@2.0.0`}</inlineCode></a>{` 开始，你可以在执行脚本时使用自定义参数。 有关详细信息，请参阅 `}<a parentName="p" {...{
        "href": "/cli/v6/commands/npm-run-script"
      }}><inlineCode parentName="a">{`npm run-script`}</inlineCode></a>{`。`}</p>
    <a id="see-also"></a>
    <h3>{`也可以看看`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v6/commands/npm-run-script"
        }}>{`npm run-script`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v6/using-npm/scripts"
        }}>{`npm scripts`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v6/commands/npm-test"
        }}>{`npm test`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v6/commands/npm-restart"
        }}>{`npm restart`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v6/commands/npm-stop"
        }}>{`npm stop`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      